module.exports = __webpack_public_path__ + "img/Quais-beneficios-um-software-para-gestao-de-obra-proporciona.dd28b985.jpg";